// Import necessary react hooks
import { useState } from "react";
// Import necessary Material-UI components
import { Grid, Box } from "@mui/material";
// Import necessary Material-UI Datagrid components
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// Import necessary utility functions
import { CreateTableColumns } from "../functions";
import { CustomMUITableContainer } from "./customMUIComponents";

/**
 * common DataGridTable component for rendering a
 * custom MUI Datagrid across most of the application
 * @param {Object} props - Component props including data, and callbacks.
 */
export function DataGridTable({
  data,
  handleRowClick,
  title,
  description,
  button,
  initialState,
  detailsBool,
  onCellClick,
  checkBoxBool,
  onRowsSelectionHandler,
  isRowSelectable,
  sampleRequestID,
  filterModel,
  filterCheckbox,
  setFilterModel,
  createColumns,
  loading,
  columnGrouping,
  columnGroupingModel,
}) {
  // State to manage the page size of the data grid
  const [pageSize, setPageSize] = useState(25);

  // Assign an ID to each item in the data array

  data?.forEach((item, i) => {
    item.id = i + 1;
  });

  // Function to determine if a row is selectable based on the isRowSelectable prop
  const selectableRow = (params) => {
    switch (isRowSelectable) {
      case "supplierList":
        // Check if the supplier list meets the required number of samples
        if (params.row.supplierList.length >= params.row.noOfSamplesRequired) {
          return false;
        } else {
          return true;
        }
      case "hodApproval":
        // Check if there's an item in the supplier list that meets specific conditions
        const exists = params.row.supplierList.some(
          (item) =>
            item.execChefApproval &&
            item.execChefApproval.status === "Accepted" &&
            item.HODApproval.status === "pending"
        );

        if (params.row.supplierList.length > 0 && exists) {
          return true;
        } else {
          return false;
        }
      default:
      //Do nothing here
    }
  };
  return (
    <CustomMUITableContainer>
      <Box>
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={6}>
            <h2 style={{ paddingLeft: "20px" }}>{title}</h2>
            <p style={{ paddingLeft: "20px" }}>{description}</p>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {button && button}
          </Grid>
        </Grid>
        {filterCheckbox && filterCheckbox}
        <Box
          sx={{
            "& .detailsColumn": {
              display: "flex !important",
              alignItems: "flex-start !important",
            },
          }}
        >
          <DataGrid
            rows={data ? data : []}
            loading={loading === false ? false : !data || data.length === 0}
            autoHeight={true}
            columns={
              // Determine the columns for the data grid
              createColumns
                ? createColumns()
                : CreateTableColumns({ data, detailsBool, sampleRequestID })
            }
            initialState={{
              pagination: { paginationModel: { pageSize: pageSize } },
            }}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            onRowClick={handleRowClick ? (e) => handleRowClick(e) : null}
            components={{ Toolbar: GridToolbar }}
            getRowHeight={() => "auto"}
            disableRowSelectionOnClick
            onCellClick={onCellClick}
            checkboxSelection={checkBoxBool}
            onRowSelectionModelChange={(ids) => {
              onRowsSelectionHandler(ids);
            }}
            isRowSelectable={(params) => selectableRow(params)}
            filterModel={filterModel}
            onFilterModelChange={(newFilterModel) =>
              setFilterModel ? setFilterModel(newFilterModel) : () => {}
            }
            getCellClassName={(params) => {
              // Custom class name for the "Details" column
              if (params.field === "Details") {
                return "detailsColumn";
              }
            }}
            experimentalFeatures={{ columnGrouping: columnGrouping }}
            columnGroupingModel={columnGroupingModel}
            sx={{
              border: 0,
            }}
          />
        </Box>
      </Box>
    </CustomMUITableContainer>
  );
}
